import React, { useEffect } from 'react'
import * as d3 from "d3";
import Text from './view01/text';
import Chart from './view01/chart';

function View01 (props){
    const data = props.data,
        biobanks = props.biobanks,
        betas = props.betas,
        types = props.types,
        AFs = props.AFs,
        chr = props.chr,
        pos = props.pos,
        refV = props.refV,
        altV = props.altV,
        dna = props.dna,
        topLoci = props?.topLoci,
        width = props.width,
        settings = props.settings,
        slotEx = props.slotEx,
        setSlot = props.setSlot,
        defineMinPval = props.defineMinPval,
        setLocus = props.setLocus,
        slot = props.slot,
        format = props.format,
        ranges = props.ranges,
        setRanges = props.setRanges,
        extra = props.extra,
        getExtra = props.getExtra;

    const [topView, setTopView] = React.useState(['cht', 'gnm', undefined]);

    function updateMode (mode) {

        if (mode === 'chart') d3.select('#table').selectAll('.section').transition().duration(500).style('opacity', 0)
        else if (mode === 'text') d3.select('#chart').transition().duration(500).style('opacity', 0)
        
        d3.selectAll('#view02, #view03').transition().duration(500).style('opacity', 0);
        setTimeout(update, 500)
    
        function update(){
            if (mode === 'chart') setTopView(['cht', 'gnm', undefined])
            else if (mode === 'text') setTopView(['txt', undefined, undefined])
            setLocus({});
            setSlot({});
        }
    }

    d3.select('#b_modeChart')
        .classed('buttonPrimary', topView[0] === 'cht' ? true : false)
        .style('border-width', () => {if (topView[0] === 'txt') return '1px 0 1px 1px'})
        .on('click', () => updateMode('chart'));

    d3.select('#b_modeText')
        .classed('buttonPrimary', topView[0] === 'txt' ? true : false)
        .style('border-width', () => {if (topView[0] === 'cht') return '1px 1px 1px 0'})
        .on('click', () => updateMode('text'));
    
    d3.select('#b_tableSize').style('display', topView[0] === 'txt' ? undefined : 'none');

    useEffect(()=>{
    })

    return (
        <div id="view01">
            {topView[0] === 'txt' && (
                <Text
                    data={data} 
                    topLoci={topLoci}
                    biobanks={biobanks} 
                    pos={pos}
                    chr={chr}
                    refV={refV}
                    altV={altV}
                    AFs={AFs}
                    betas={betas}
                    slot={slot}
                    setSlot={setSlot}
                    defineMinPval={defineMinPval}
                    setLocus={setLocus}
                    format={format}
                    extra={extra}
                    getExtra={getExtra}
                    settings={settings}
                    />
            )}
            {topView[0] === 'cht' && (
                <Chart 
                    data={data} 
                    biobanks={biobanks} 
                    ranges={ranges}
                    setRanges={setRanges}
                    chr={chr} 
                    pos={pos}
                    dna={dna}
                    width={width}
                    settings={settings}
                    topView={topView}
                    setTopView={setTopView}
                    setLocus={setLocus}
                    slotEx={slotEx}
                    setSlot={setSlot}
                    defineMinPval={defineMinPval}
                    format={format}
                    types={types}
                    /> 
            )}
        </div>
    )
}
export default View01;